import React from 'react'

function SearchOptions() {
    return (
        <div className='App__SearchOptions'>
            <nav className="mainMenu">
                <ul>
                    <li><a href="#">Dictionary</a></li>
                    <li><a href="#">Thesaurus</a></li>
                    <li><a href="#">Examples</a></li>
                    <li><a href="#">Sentences</a></li>
                    <li><a href="#">Quotes</a></li>
                </ul>
            </nav>
        </div>
    )
}

export default SearchOptions
